// extracted by mini-css-extract-plugin
module.exports = {"main":"FinalSidebar_main__1qMQX","clicked":"FinalSidebar_clicked__3_lrB"};